<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="pallet">
			<BreadCrumb slot="header"></BreadCrumb>
			<search @onSubmit="onSubmit" ref="search" />
		</Panel>
		<Panel>
			<div class="btn-box flex pb-24 flex-align-center">
				<el-button @click="addTag">添加标签</el-button>
				<p class="yx-color-pure-1 ml-16 fz-14">
					共 <span class="yx-color-primary">{{ total }}</span> 个标签
				</p>
			</div>
			<multi-table :list="list" v-loading="loading" :page="pageInfo" :columns="columns" @gePartnerList="pagerList" :total="total">
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</Panel>

		<add-tag ref="addTag" @refreshList="refreshList"></add-tag>
		<del-dialog ref="del" @refreshList="refreshList"></del-dialog>
	</div>
</template>
<script>
import search from '../components/search.vue';
import empty from '@/views/common/empty/index.vue';
import { tagsList } from '@/api/shopManage';
import AddTag from '../components/addTag.vue';
import delDialog from '../components/del.vue';
import getColumns from '../columns';
export default {
	components: {
		search,
		empty,
		AddTag,
		delDialog,
	},
	data() {
		return {
			list: [],
			isSearch: false,
			loading: false,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: 0,
			params: {},
			columns: getColumns(this),
		};
	},
	created() {
		this.getList();
	},
	methods: {
		async getList(isSearch) {
			this.isSearch = Boolean(isSearch);
			this.loading = true;
			const {
				code,
				data: { list = [], page = {} },
			} = await tagsList({ ...this.pageInfo, ...this.params, type: '1' }); //0商品标签， 1达人标签
			if (code !== 0) return;
			this.loading = false;
			this.total = `${page.item_total}`;
			this.list = list.map(item => ({
				...item,
				operations: this.getButtons(item),
			}));
		},
		skipUrl({ id, tag_name }) {
			let handLink = this.$router.resolve({
				path: '/talentCRM/groupSeas',
				query: {
					tag_id: id,
					tag_name,
				},
			});
			window.open(handLink.href, '_blank');
		},
		addTag() {
			this.$refs.addTag.show('添加标签', 'add');
		},
		edit(row) {
			this.$refs.addTag.show('编辑标签', 'edit', row);
		},
		del({ id }) {
			this.$refs.del.show(id);
		},
		pagerList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		refreshList() {
			this.getList();
		},
		onSubmit(val) {
			this.pageInfo.page_index = 1;
			this.params = val;
			this.getList(1);
		},
		getButtons() {
			const arr = [];
			arr.push(
				{
					label: '编辑',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => this.edit(row),
				},
				{
					label: '删除',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => this.del(row),
				},
			);
			return arr;
		},
	},
};
</script>
<style lang='less' scoped>
</style>